/*
  Shared countdown for the TOFU landers. Any element with data-tofu-cd="<ISO date>"
  ticks: its [data-cd="d|h|m|s"] children get the time left, zero-padded. Liquid
  prints the same numbers first, so the countdown reads right before this runs.
  data-cd-hide-expired hides the element once the date passes.

  Several sections on one page can load this file; the flag keeps one timer.
*/
(function () {
  if (window.__tofuCountdown) return;
  window.__tofuCountdown = true;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-tofu-cd]').forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-tofu-cd'));
      if (isNaN(end)) return;
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var parts = {
        d: Math.floor(left / 86400),
        h: Math.floor((left % 86400) / 3600),
        m: Math.floor((left % 3600) / 60),
        s: left % 60
      };
      el.querySelectorAll('[data-cd]').forEach(function (unit) {
        var v = parts[unit.getAttribute('data-cd')];
        if (v !== undefined) unit.textContent = pad(v);
      });
      if (left === 0 && el.hasAttribute('data-cd-hide-expired')) el.hidden = true;
    });
  }

  tick();
  setInterval(tick, 1000);
})();
